import { SET_USER, RESET_LOGIN_ERROR, LOGIN_ERROR } from "./types";
import { auth } from "../../config/firebase";
import axios from "axios";
import { deleteCookie, getCookie } from "../../utils/cookies";

export const setAuthToken = (token) => {
  if (token) {
    axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  } else {
    delete axios.defaults.headers.common["Authorization"];
  }
};

export const setNullUser = () => async () => {
  try {
    setAuthToken();
  } catch (error) {
    return error;
  }
};

export const refreshToken = () => async (dispatch) => {
  try {
    const token = getCookie("_session");
    const sessionDetails = await axios.get(
      `${process.env.REACT_APP_GOLANG_API}/api/v2/auth/generate`,
      {
        headers: { Authorization: `Bearer ${JSON.parse(token)}` },
      },
    );

    if (window.location.hostname === "localhost" || /^\d+\.\d+\.\d+\.\d+$/.test(window.location.hostname)) {
      document.cookie = `_session=${JSON.stringify(
        sessionDetails.data.token,
      )}; path=/`;
    } else {
      // For domain names
      const hostParts = window.location.hostname.split(".");
      if (hostParts.length >= 2) {
        const domain = `.${hostParts[hostParts.length - 2]}.${hostParts[hostParts.length - 1]}`;
        document.cookie = `_session=${JSON.stringify(
          sessionDetails.data.token,
        )}; domain=${domain}; secure; path=/`;
      } else {
        // Fallback for single-level domains
        document.cookie = `_session=${JSON.stringify(
          sessionDetails.data.token,
        )}; path=/`;
      }
    }
  } catch (error) {
    const token = getCookie("_session");
    const sessionDetails = await axios.get(
      `${process.env.REACT_APP_GOLANG_API}/api/v2/auth/generate`,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    if (window.location.hostname === "localhost" || /^\d+\.\d+\.\d+\.\d+$/.test(window.location.hostname)) {
      document.cookie = `_session=${JSON.stringify(
        sessionDetails.data.token,
      )}; path=/`;
    } else {
      // For domain names
      const hostParts = window.location.hostname.split(".");
      if (hostParts.length >= 2) {
        const domain = `.${hostParts[hostParts.length - 2]}.${hostParts[hostParts.length - 1]}`;
        document.cookie = `_session=${JSON.stringify(
          sessionDetails.data.token,
        )}; domain=${domain}; secure; path=/`;
      } else {
        // Fallback for single-level domains
        document.cookie = `_session=${JSON.stringify(
          sessionDetails.data.token,
        )}; path=/`;
      }
    }
  }
};

export const setUser = (user, isFromLogin) => async (dispatch) => {
  try {
    const { token } = await user.getIdTokenResult();
    const sessionDetails = await axios.get(
      `${process.env.REACT_APP_GOLANG_API}/api/v2/auth/generate`,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    if (window.location.hostname === "localhost" || /^\d+\.\d+\.\d+\.\d+$/.test(window.location.hostname)) {
      document.cookie = `_session=${JSON.stringify(
        sessionDetails.data.token,
      )}; path=/`;
    } else {
      // For domain names
      const hostParts = window.location.hostname.split(".");
      if (hostParts.length >= 2) {
        const domain = `.${hostParts[hostParts.length - 2]}.${hostParts[hostParts.length - 1]}`;
        document.cookie = `_session=${JSON.stringify(
          sessionDetails.data.token,
        )}; domain=${domain}; secure; path=/`;
      } else {
        // Fallback for single-level domains
        document.cookie = `_session=${JSON.stringify(
          sessionDetails.data.token,
        )}; path=/`;
      }
    }

    dispatch({
      type: SET_USER,
      payload: {
        ...sessionDetails.data.user,
        name:
          sessionDetails.data.user.displayName || sessionDetails.data.user.name,
        authorPhotoURL: user.photoURL || sessionDetails.data.user.photoURL,
      },
    });

    if (isFromLogin) {
      return (window.location.href = window.location.origin + "/");
    }
  } catch (error) {
    return dispatch({
      type: LOGIN_ERROR,
      payload: error.message,
    });
  }
};

export const resetLoginError = () => ({
  type: RESET_LOGIN_ERROR,
});

export const logOut = () => async (dispatch) => {
  await auth.signOut().then(() => {
    setAuthToken();
    dispatch({
      type: SET_USER,
      payload: null,
    });
  });
  deleteCookie("user_details");
  deleteCookie("isNewUser");
  
  // Delete session cookie properly for all environments
  if (window.location.hostname === "localhost" || /^\d+\.\d+\.\d+\.\d+$/.test(window.location.hostname)) {
    deleteCookie("_session");
  } else {
    const hostParts = window.location.hostname.split(".");
    if (hostParts.length >= 2) {
      const domain = `.${hostParts[hostParts.length - 2]}.${hostParts[hostParts.length - 1]}`;
      deleteCookie("_session", domain);
    }
    deleteCookie("_session");
  }
  localStorage.removeItem("emailForSignIn");
  window.location.href = window.location.origin + "/login";
};
